import React, { useContext, useEffect, useState } from "react";
import "./Notification_Offcanvas.css";
import { Offcanvas } from "react-bootstrap";
import { getNotification } from "../../../../utils/apis/notification/notification";
import CustomPaginate from "../../custompaginate/CustomPaginate";
import { Context } from "../../../../utils/context";

const Notification_Offcanvas = (props) => {
  const { signin } = useContext(Context);
  const [notificationData, setNotificationData] = useState({
    data: [],
    current_page: 1,
    total_pages: 1,
  });


  const getAllNotification = async (name = "", page = 1, perPage = 10) => {
    // if (signin) {
    const res = await getNotification(name, page, perPage);
    if (res?.success) {
      setNotificationData({
        data: res.data.data, // actual notification array
        current_page: res.data.current_page,
        total_pages: res.data.total_pages,
      });
    }
    // }
  };

  useEffect(() => {
    getAllNotification();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const [name, setName] = useState("");
  const [perPage, setPerPage] = useState(10);

  const handlePageChange = async (page) => {
    setCurrentPage(page);
    await getAllNotification(name, page, perPage);
  };

  useEffect(() => {
    getAllNotification(name, currentPage, perPage);
  }, [name, currentPage, perPage]);

  return (
    <div className="Notification_Offcanvas">
      <Offcanvas className="notification_offcanvas" {...props} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Notification</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="main_div">
            {notificationData?.data?.map((data, index) => (
              <div key={index} className="notification-item">
                <p className="text_title">{data?.name}</p>
                <p className="text">{data?.remark}</p>
                <b>
                  {" "}
                  <p className="text text-right">
                    {new Date(data?.createdAt).toLocaleString("en-GB", {
                      day: "numeric",
                      month: "numeric",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </p>
                </b>

                <br></br>
              </div>
            ))}
          </div>
          <CustomPaginate
            currentPage={notificationData?.current_page}
            totalPages={notificationData?.total_pages}
            handlePageChange={handlePageChange}
          />
        </Offcanvas.Body>{" "}
      </Offcanvas>{" "}
    </div>
  );
};

export default Notification_Offcanvas;
